import { jsx as _jsx } from "react/jsx-runtime";
import { EventItem } from 'console/tabs/events/components/event-item';
import { Box } from '@mui/material';
import { useAction } from 'shared/hooks/redux/hooks';
import { useCallbacks, usePartial } from 'shared/hooks/utils';
import { pickDevice } from 'console/redux/main-actions';
import { leaveFromDashboard } from 'console/dashboards/z3k/actions';
export function DevicesEventsItem({ devices_event }) {
    const onDeviceClick = useCallbacks([
        useAction(usePartial(pickDevice, devices_event.device_id)),
        useAction(leaveFromDashboard),
    ]);
    return (_jsx(Box, { borderBottom: "1px solid #B1B1B1", onClick: onDeviceClick, children: _jsx(EventItem, { loc_event: devices_event.localizedEvent, device_id: devices_event.device_id, isDeviceAllEvents: true }) }));
}
